enum ConditionalApprovalStatusEnum {
    Approved = 'APPROVED',
    Draft = 'DRAFT',
    Legacy = 'LEGACY',
}

export default ConditionalApprovalStatusEnum;
